import {callApi} from "./api";
import * as contract from "../contract";

// A spoken summary of a day, this week or next week (see contract/briefing.ts). Takes a while: it is written, then read out.
export const getBriefingQuery = (boardId: string, request: contract.BodyInput<typeof contract.briefing.generateBriefing>) =>
    callApi(contract.briefing.generateBriefing, { params: { boardId }, body: request });
